module.exports = {"110106001":"右安门街道","110106002":"太平桥街道","110106003":"西罗园街道","110106004":"大红门街道","110106005":"南苑街道","110106006":"东高地街道","110106007":"东铁匠营街道","110106008":"卢沟桥街道","110106009":"丰台街道","110106010":"新村街道","110106011":"长辛店街道","110106012":"云岗街道","110106013":"方庄地区","110106014":"宛平城地区","110106015":"马家堡街道","110106016":"和义街道","110106017":"卢沟桥地区","110106018":"花乡地区","110106019":"南苑地区","110106100":"长辛店镇","110106101":"王佐镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110106.json
// module id = 25
// module chunks = 0